import BaseControllerManager from 'js/app/base/BaseControllerManager'

export default class ControllerManager extends BaseControllerManager {
  constructor(ViewControllers, Router, useAjax) {
    super(ViewControllers)
    this.router = Router
    this.useAjax = useAjax
  }

  getController(ID = null, content = null) {
    let controller

    if (ID !== null && this._VC[ID] !== null && this._VC[ID] !== undefined) {
      controller = new this._VC[ID](content)
    } else if (content !== null && isSet(this._VC[content.getAttribute('data-use-controller')])) {
      controller = new this._VC[content.getAttribute('data-use-controller')](content)
    } else if (content !== null && isSet(this._VC[content.getAttribute('id')])) {
      controller = new this._VC[content.getAttribute('id')](content)
    } else {
      controller = new this._VC['default'](content)
    }

    return controller
  }
}
